import { render, staticRenderFns } from "./ImagesUploader.vue?vue&type=template&id=ffa6f39c&scoped=true&"
import script from "./ImagesUploader.vue?vue&type=script&lang=ts&"
export * from "./ImagesUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesUploader.vue?vue&type=style&index=0&id=ffa6f39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa6f39c",
  null
  
)

export default component.exports